import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';

export const ClientsPageComponent = (): JSX.Element => <div data-cy="clients-page" />;

export const ClientsPageQuery = graphql`
	query ClientsPage_Query {
		viewer {
			id
			...ClientsPage_viewer
		}
	}
`;

export default createFragmentContainer(ClientsPageComponent, {
	viewer: graphql`
		fragment ClientsPage_viewer on Viewer {
			id
		}
	`,
});
